import { executeRequest, JFSRequest } from '@jfs/network'
import { RootStore } from '../data/store'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'
import { getFormattedDate, getRequestFromEntityFormData } from './eosCreateWorkItem'

const getRequest = ({ editedValues, ...additionalReq }: any, originalData: any, metaData, dedupeData: any) => {
  return {
    applicationId: `UPDATE-${getFormattedDate()}`,
    merchantId: editedValues?.entityId,
    originalMerchant: {
      ...getRequestFromEntityFormData(originalData, metaData, {}).merchant,
      entityIdentificationNumber: originalData?.entityId,
    },
    merchant: {
      ...getRequestFromEntityFormData(editedValues, metaData, dedupeData).merchant,
      entityIdentificationNumber: editedValues?.entityId,
    },

    skipDedupe: true,
    realtimeDedupeSearchResponse: dedupeData,
    ...additionalReq,
  }
}

const responseParser = (response: any) => {
  return isSuccessResponse(response)
}

const updateExistingEntity = (entityData: any, originalData: any, ddListData: any, dedupeData: any) => {
  console.log('htag req original1')
  console.log('htag req original', getRequest(entityData, originalData, ddListData, dedupeData))
  const request: JFSRequest<{}> = {
    apiPath: getUrl(
      entityData?.opsMakerActionType ? APIEndPoints.updateExistingEntity : APIEndPoints.riskMakerExistingEntity,
    ),
    method: 'POST',
    config: sitConfig(RootStore.session.getTokens),
    headers: getHeaders(),
    body: {
      ...getRequest(entityData, originalData, ddListData, dedupeData),
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export const updateExistingEntityForIntraction = (reqBody: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.riskMakerExistingEntity),
    method: 'POST',
    config: sitConfig(RootStore.session.getTokens),
    headers: getHeaders(),
    body: reqBody,
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export const updateExistingEntityForIntractionReq = (entityData, additionalData, metaData, reqId) => {
  return {
    applicationId: reqId,
    merchantId: entityData?.entityId,
    originalMerchant: entityData,
    merchant: entityData,
    skipDedupe: true,
    ...additionalData,
  }
}

export { updateExistingEntity }
